import { Injectable } from '@angular/core';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [
  {
    id: 'dashboard',
    title: 'DashBoard',
    type: 'group',
    icon: 'feather icon-box',
    children: [
      {
        id: 'dashboard',
        title: 'DashBoard',
        type: 'collapse',
        icon: 'feather icon-box',
        children: [
          {
            id: 'rrms-dashboard',
            title: 'RRMS Dashboard',
            type: 'item',
            icon: 'feather icon-box',
            url: '/dashboard/rrms-dashboard'
          }]
      }]
  },{
    id: 'summary',
    title: 'DashBoard',
    type: 'group',
    icon: 'feather icon-box',
    children: [
      {
        id: 'summary',
        title: 'Summary',
        type: 'item',
        icon: 'feather icon-box',
        url: '/Summary'
        // children: [
        //   {
        //     id: 'Ecowas',
        //     title: 'Ecowas',
        //     type: 'item',
        //     url: '/Ecowas'
        //   }]
      }]
  },
  {
    id: 'campaign',
    title: 'Campaign',
    type: 'group',
    icon: 'feather icon-box',
    children: [
      // {
      //   id: 'Campaign',
      //   title: 'Campaign Management',
      //   type: 'collapse',
      //   icon: 'feather icon-box',
      //   children: [
          {
            id: 'campaign',
            title: 'Campaign Management',
            type: 'item',
            url: '/Campaign'
          },
        // ]
      // }
    ]
  },
  {
    id: 'bussiness',
    title: 'Bussiness Management',
    type: 'group',
    icon: 'feather icon-box',
    children: [
      {
        id: 'bussiness',
        title: 'Business Management',
        type: 'collapse',
        icon: 'feather icon-box',
        children: [
        
          {
            id: 'community',
            title: 'Add Community',
            type: 'item',
            url: '/community'

          },
          {
            id: 'business-rules',
            title: 'Business Rules',
            type: 'item',
            url: '/BusinessRules'

          }
        ]
      }
    ]
  },
  // {
  //   id: 'community',
  //   title: 'community',
  //   type: 'group',
  //   icon: 'feather icon-box',
  //   children: [
      // {
      //   id: 'community',
      //   title: 'comminity',
      //   type: 'collapse',
      //   icon: 'feather icon-box',
      //   children: [
          // {
          //   id: 'Community',
          //   title: 'Add Community',
          //   type: 'item',
          //   url: '/community'

          // }
        // ]
      // }
  //   ]
  // },
  {
    id: 'roamers',
    title: 'Roamers',
    type: 'group',
    icon: 'feather icon-box',
    children: [
      {
        id: 'roamers',
        title: 'Roamers',
        type: 'collapse',
        icon: 'feather icon-box',
        children: [
          {
            id: 'roamers-segment',
            title: 'Roamers Segment',
            type: 'item',
            url: '/roamers/roamers-segment'
          },
          {
            id: 'roamers-count-history',
            title: 'Roamers Count History',
            type: 'item',
            url: '/roamers/roamers-count-history'
          },
          {
            id: 'price-point-history',
            title: 'Price Point History',
            type: 'item',
            url: '/roamers/price-point-history'
          }, {
            id: 'roamers-pack-history',
            title: 'Roamers Pack History',
            type: 'item',
            url: '/roamers/roamers-pack-history'
          }, {
            id: 'roamfree-in-error-code',
            title: 'Roamfree In Error Code',
            type: 'item',
            url: '/roamers/roamfree-in-error-code'
          }, {
            id: 'in-statistics',
            title: 'In Statistics',
            type: 'item',
            url: '/roamers/in-statistics'
          },
          {
            id: 'message-count',
            title: 'Message Count',
            type: 'item',
            url: '/roamers/message-count'
          },{
            id: 'repitive-count',
            title: 'Repititive Count',
            type: 'item',
            url: '/roamers/repitive-count'
          },{
            id: 'vlrid-unblock-count',
            title: 'Vlrid Unblock Count',
            type: 'item',
            url: '/roamers/vlrid-unblock-count'
          },{
            id: 'rrms-active-deactive-msisdn',
            title: 'Rrms Active And Deactive',
            type: 'item',
            url: '/roamers/rrms-active-deactive-msisdn'
          },
          {
            id: 'rrms-day-wise-reports',
            title: 'RRMS Day Wise Reports',
            type: 'item',
            url: '/roamers/rrms-day-wise-reports'
          },
          //  {
          //   id: 'message-delivery-statistics',
          //   title: 'Message Delivery Statistics',
          //   type: 'item',
          //   url: '/roamers/message-delivery-statistics'
          // }
        ]
      }
    ]
  }, {
    id: 'tarriff',
    title: 'Tarriff',
    type: 'group',
    icon: 'feather icon-box',
    children: [
      {
        id: 'tarriff',
        title: 'Tarriff',
        type: 'item',
        icon: 'feather icon-box',
        url: '/tarriff'
      }
    ]
  }
  , {
    id: 'blacklist',
    title: 'Blacklist',
    type: 'group',
    icon: 'feather icon-box',
    children: [
      {
        id: 'blacklist',
        title: 'Blacklist',
        type: 'item',
        icon: 'feather icon-box',
        url: '/blacklist'
      }
    ]
  }
      , {
        id: 'user-analytics',
        title: 'User Analytics',
        type: 'group',
        icon: 'feather icon-box',
        children: [
          {
            id: 'user-analytics',
            title: 'User Analytics',
            type: 'collapse',
            icon: 'feather icon-box',
            children: [
              {
                id: 'user-analytics',
                title: 'User Analytics',
                type: 'item',
                url: '/user-analytics/user-analytics'
              }
            ]
          }
        ]
      },
      {
        id: 'whitelist',
        title: 'Whitelist',
        type: 'group',
        icon: 'feather icon-box',
        children: [
          {
            id: 'whitelist',
            title: 'Whitelist',
            type: 'item',
            icon: 'feather icon-box',
            url: '/whitelist'
          }
        ]
        }
      ,{
        id: 'report',
        title: 'Report',
        type: 'group',
        icon: 'feather icon-box',
        children: [
          {
            id: 'report',
            title: 'Report',
            type: 'item',
            icon: 'feather icon-box',
            url: '/report'
          }
        ]
        },{
        id: 'subscriber-pack-info',
        title: 'Subscriber Pack Info',
        type: 'group',
        icon: 'feather icon-box',
        children: [
          {
            id: 'subscriber-pack-info',
            title: 'Subscriber Pack Info',
            type: 'item',
            icon: 'feather icon-box',
            url: '/subscriber-info/subscriber-info'
          },
          {
            id: 'delete-offer',
            title: 'Delete Offer',
            type: 'item',
            icon: 'feather icon-box',
            url: '/subscriber-info/delete-offer'
          }
        ]
        },{
          id: 'sms-pdp',
          title: 'SMS PDP',
          type: 'group',
          icon: 'feather icon-box',
          children: [
            {
              id: 'sms-pdp',
              title: 'SMS PDP',
              type: 'collapse',
              icon: 'feather icon-box',
              children: [
              
                {
                  id: 'configure',
                  title: 'Configure',
                  type: 'item',
                  url: '/sms-pdp/configure'
      
                },
                {
                  id: 'history',
                  title: 'History',
                  type: 'item',
                  url: '/sms-pdp/history'
      
                },
                {
                  id: 'smspdp-repitive-count',
                  title: 'SMSPDP Repitive Count',
                  type: 'item',
                  url: '/sms-pdp/smspdp-repitive-count'
                },  
                {
                  id: 'smspdp-active-deactive-msisdn',
                  title: 'SMSPDP Active Deactive Msisdn',
                  type: 'item',
                  url: '/sms-pdp/smspdp-active-deactive-msisdn'
                },
                {
                  id: 'view-configure',
                  title: 'View Configure',
                  type: 'item',
                  url: '/sms-pdp/view-configure'
      
                },
                {
                  id: 'day-wise-reports',
                  title: 'Day Wise Reports',
                  type: 'item',
                  url: '/sms-pdp/day-wise-reports'
      
                },
                ,{
                  id: 'sms-pdp-vlrid-count',
                  title: 'SMS PDP Vlrid Count',
                  type: 'item',
                  url: '/sms-pdp/sms-pdp-vlrid-count'
                },
              ]
            }
          ]
        },
        {
          id: 'access-management',
          title: 'Access-management',
          type: 'group',
          icon: 'feather icon-box',
          children: [
            {
              id: 'access-management',
              title: 'Access-management',
              type: 'collapse',
              icon: 'feather icon-box',
              children: [
                {
                  id: 'user',
                  title: 'User',
                  type: 'item',
                  url: '/access-management/user'
                },
                {
                  id: 'role',
                  title: 'Role',
                  type: 'item',
                  url: '/access-management/role'
                }
              ]
            }           
          ]
        },
        {
          id: 'service-live-dashboard',
          title: 'Service Live Dashboard',
          type: 'group',
          icon: 'feather icon-box',
          children: [
            {
              id: 'service-live-dashboard',
              title: 'Service Live Dashboard',
              type: 'collapse',
              icon: 'feather icon-box', 
              children: [
                  {
                    id: 'rrms-service-live-dashboard',
                    title: 'RRMS Service Live Dashboard' ,
                     type: 'item',
                     url: '/service-live-dasdhboard/rrms-service-live-dashboard' 
                  },
                   {
                    id: "sms-pdp-live-mapping-dashboard",
                    title: "SMSPDP Service Live Dashboard",
                    type: "item",
                    url: "/service-live-dashboard/sms-pdp-live-mapping-dashboard"
                  },
                 
                  {
                    id: 'networkAddition',
                    title: 'SMS PDP Service Live Dashboard' ,
                     type: 'item',
                     url: '/service-live-dasdhboard/sms-pdp-service-live-dashboard' 
                  },    
                  {
                    id: 'sms-pdp-service-live-dashboard',
                    title : 'Network Addition',
                    type: 'item',
                    url: '/service-live-dashboard/networkAddition'}
                ]
            }
          ]
        },
        {
          id: 'network_addition',
          title: 'Network Addition',
          type: 'group',
          icon: 'feather icon-box',
          children: [
            {
              id: 'network_addition',
              title: 'Network Addition',
              type: 'item',
              icon: 'feather icon-box',
              url: '/network_addition'
            }
          ]
        }
 
];

@Injectable()
export class NavigationItem {
  userRoleRights: any = [];
  public get() {
    // return NavigationItems;
     return this.userRoleRights;
  }

  constructor() {

    if (sessionStorage.getItem('ecowas_user_roles') !== null) {
      this.userRoleRights =  [...JSON.parse(sessionStorage.getItem('ecowas_user_roles'))];
    }
    
    // if (sessionStorage.getItem('rms_user_roles') !== null) {
    //   this.userRoleRights =  [...JSON.parse(sessionStorage.getItem('rms_use 
    //   for (let roles of userRoles) {
    //     if (items.title === roles.title) {
    //       this.userRoleRights.push(roles);
    //      // this.deleteItem()
    //     }
    //   }
    // }
    
  }

  deleteItem(array, val) {
    const index = array.findIndex(x => x.title === val);
    array.splice(index, 1);
  }
}